import ECharts from './echarts';

require('echarts/lib/chart/line');
require('echarts/lib/chart/scatter');
require('echarts/lib/chart/pie');
require('echarts/lib/chart/radar');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
require('echarts/lib/chart/gauge');
require('echarts/lib/chart/custom');
// 引入地图
require('echarts/lib/chart/map');
require('echarts/lib/chart/effectScatter');


require('echarts/lib/component/tooltip');
require('echarts/lib/component/legend');
require('echarts/lib/component/title');
require('echarts/lib/component/toolbox');
require('echarts/lib/component/polar');
require('echarts/lib/component/geo');
// 数据缩小的视图
require('echarts/lib/component/dataZoom');
//图表的标线
require('echarts/lib/component/markLine');
// 图表最大值和最小值
require('echarts/lib/component/markPoint');
//设置基线上下的颜色
require('echarts/lib/component/visualMap');

require('echarts/lib/component/graphic');
require('echarts/lib/component/legendScroll');
export default ECharts;
